module.exports = __webpack_public_path__ + "static/media/handing-over-package.f8fabf90.jpg";